import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig';
import { csv } from 'd3-fetch';

export const APP_NAME = 'Nagaco';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const NOTI_SERVICE_URL = env.NOTI_SERVICE_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect';
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/system_list`;
export const UNAUTHENTICATED_ENTRY = '/login';

export const EDITOR_API_KEY = 'b5po5o74aat9p0538x0cd2b1y31zb6pjsg36z722xxa3nllf';

export const THEME_CONFIG = {
    navCollapsed: false,
    sideNavTheme: SIDE_NAV_LIGHT,
    locale: localStorage.getItem('i18nextLng') || 'vi',
    navType: NAV_TYPE_SIDE,
    topNavColor: '#3e82f7',
    headerNavColor: '',
    mobileNav: false,
    currentTheme: localStorage.getItem('theme') || 'light',
    direction: DIR_LTR,
    blankLayout: false,
};

export const OPENID_MODE = {
    add: 'ADD',
    detail: 'DETAIL',
    edit: 'EDIT',
    export: 'EXPORT',
    export_one: 'EXPORT_ONE',
    import: 'IMPORT',
    list: 'LIST',
    masscopy: 'MASSCOPY',
    copy: 'COPY',
    trash: 'TRASH',
};

export const EXPORT_TYPE = {
    pdf: 'pdf',
    csv: 'csv',
    xlsx: 'xlsx',
    json: 'json',
    docx: 'docx',
    xml: 'xml',
};

export const EXPORT_VALUE = {
    pdf: '1',
    xml: '2',
    xlsx: '3',
    json: '4',
    docx: '5',
    csv: '6',
    export_with_template : 'export_with_template',
    export_new_template: 'export_new_template'
};

export const IMPORT_TYPE = {
    xlsx: 'xlsx',
    xml: 'xml',
    json: 'json',
    csv: 'csv',
};

export const IMPORT_VALUE = {
    xlsx: '1',
    xml: '2',
    json: '3',
    csv: '4',
};

export const FUNCTION_ID = {
    list: '01',
    edit: '02',
    add: '03',
    detail: '04',
    import: '05',
    export: '06',
    mass_copy: '07',
    help: '08',
};

export const CATEGORY_PREFIX = {
    supplier: 'FOB_CAT_SUPP',

    color: 'FOB_CAT_COLR',
};

export const SYSTEM_CODE = 'OPENID'